import styled from 'styled-components';

export const DetailsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const ContentText = styled.div`
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  padding-top: 32px;
`;
